import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "../utils";
import { baseQueryWithReauth } from "../baseQueryWithReauth";
import { serializeArgsWithoutToken } from "../serializeQueryArgs";

const reportsApi = createApi({
  reducerPath: "reports",
  baseQuery: baseQueryWithReauth,
  serializeQueryArgs: serializeArgsWithoutToken, // #142: token önbellek anahtarına girmez
  keepUnusedDataFor: 60,
  endpoints(builder) {
    return {
      getDevicesPerformanceBetweenDatesReport: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(
            data,
            `/api/reports/storageRoles/device/devicesPerformanceBetweenDates`,
            "POST"
          ),
      }),
      getDeviceGeneralInfoReport: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/device/generalInfo`, "POST"),
      }),
      getDeviceGeneralInfoReportLazy: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/device/generalInfo`, "POST"),
      }),
      getFirmConsumentDailyReport: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/dailyConsument`, "POST"),
      }),
      getFirmConsumentMonthlyReport: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/monthlyConsument`, "POST"),
      }),
      getFirmRemainderReport: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/firmRemainder`, "POST"),
      }),
      getFirmRemainderReportLazy: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/firmRemainder`, "POST"),
      }),
      getFirmTotalConsumentReport: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/totalConsument`, "POST"),
      }),
      getNewFirmsBetweenDatesReport: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/newFirmsBetweenDates`, "POST"),
      }),
      getNewFirmsBetweenDatesReportLazy: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/newFirmsBetweenDates`, "POST"),
      }),
      getFirmsListBasedLocation: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/locationList`, "POST"),
      }),
      getFirmBillUploadOperationReport: builder.query({
        forceRefetch: () => true,
        query: (data) =>
          apiFunction(
            data,
            `/api/reports/storageRoles/firm/billUploadOperation`,
            "POST"
          ),
      }),
      // Performans raporu PDF üretir (base64) — önbelleklenecek bir veri
      // değil, bu yüzden query değil mutation.
      getFirmPerformanceReport: builder.mutation({
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/performance`, "POST"),
      }),
      // Tek firma + SERBEST tarih aralığı; aylık raporla aynı hesap/şablon,
      // fark yalnızca dönem seçimi (bkz. ReportFirmRangePerformance).
      getFirmRangePerformanceReport: builder.mutation({
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/range-performance`, "POST"),
      }),
      // Tek firma + tek gün; kırılım saat bazında.
      getFirmDailyPerformanceReport: builder.mutation({
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/daily-performance`, "POST"),
      }),
      // Çok firma + yıl; seçilen firmaların alt firma ağacı sunucuda çözülür.
      getFirmsPerformanceReport: builder.mutation({
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/firm/firms-performance`, "POST"),
      }),

      /* CİHAZ RAPORLARI — PDF (2026-09-14 kullanıcı kararı).
       *
       * PDF önbelleklenecek bir veri değil, her istekte yeniden basılan bir
       * belge; bu yüzden query değil MUTATION. Tablo uçları (yukarıdaki
       * *Query'ler) silinmedi — başka bir tüketici kalmış olabilir.
       *
       * Genel Bilgi ve Performans uçları satırları GÖVDEDE alır: sürüm
       * filtresi ve ortalama eşiği panelde uygulanıyor, belge ekrandaki
       * süzmenin birebir aynısı olmalı. Diğer dördü sunucuda yeniden
       * sorgular. */
      getDeviceConnectionInfoPdfReport: builder.mutation({
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/device/connectionInfo-pdf`, "POST"),
      }),
      getDevicesStatusBetweenDatesPdfReport: builder.mutation({
        query: (data) =>
          apiFunction(
            data,
            `/api/reports/storageRoles/device/devicesStatusBetweenDates-pdf`,
            "POST",
          ),
      }),
      getDeviceGeneralInfoPdfReport: builder.mutation({
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/device/generalInfo-pdf`, "POST"),
      }),
      getDevicePerformancePdfReport: builder.mutation({
        query: (data) =>
          apiFunction(
            data,
            `/api/reports/storageRoles/device/devicesPerformance-pdf`,
            "POST",
          ),
      }),
      // Tarihteki Makineler + Müşteri Makine Geçmişi (#356, devices-at-date-report.md)
      getDevicesAtDateReport: builder.mutation({
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/device/devicesAtDate`, "POST"),
      }),
      getFirmDeviceHistoryReport: builder.mutation({
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/device/firmDeviceHistory`, "POST"),
      }),
      getNewDevicesPdfReport: builder.mutation({
        query: (data) =>
          apiFunction(data, `/api/reports/storageRoles/device/newDevicesPdf`, "POST"),
      }),
      getDevicesServiceStatusPdfReport: builder.mutation({
        query: (data) =>
          apiFunction(
            data,
            `/api/reports/storageRoles/device/devicesServiceStatusPdf`,
            "POST",
          ),
      }),
    };
  },
});

export const {
  useGetDevicesPerformanceBetweenDatesReportQuery,
  useLazyGetDevicesPerformanceBetweenDatesReportQuery,
  useGetDeviceGeneralInfoReportQuery,
  useLazyGetDeviceGeneralInfoReportQuery,
  useGetNewFirmsBetweenDatesReportQuery,
  useLazyGetNewFirmsBetweenDatesReportLazyQuery,
  useGetFirmBillUploadOperationReportQuery,
  useLazyGetFirmBillUploadOperationReportQuery,
  useGetFirmConsumentMonthlyReportQuery,
  useLazyGetFirmConsumentMonthlyReportQuery,
  useGetFirmConsumentDailyReportQuery,
  useLazyGetFirmConsumentDailyReportQuery,
  useGetFirmsListBasedLocationQuery,
  useLazyGetFirmsListBasedLocationQuery,
  useGetFirmTotalConsumentReportQuery,
  useLazyGetFirmTotalConsumentReportQuery,
  useGetFirmRemainderReportQuery,
  useLazyGetFirmRemainderReportLazyQuery,
  useGetFirmPerformanceReportMutation,
  useGetFirmRangePerformanceReportMutation,
  useGetFirmsPerformanceReportMutation,
  useGetFirmDailyPerformanceReportMutation,
  useGetDeviceConnectionInfoPdfReportMutation,
  useGetDevicesStatusBetweenDatesPdfReportMutation,
  useGetDeviceGeneralInfoPdfReportMutation,
  useGetDevicePerformancePdfReportMutation,
  useGetNewDevicesPdfReportMutation,
  useGetDevicesServiceStatusPdfReportMutation,
  useGetDevicesAtDateReportMutation,
  useGetFirmDeviceHistoryReportMutation,
} = reportsApi;
export { reportsApi };
